import StudentLayout from "@/layout/student";
import Loader from "@quest/ui/components/loader";
import { Suspense, lazy } from "react";
import { RouteObject } from "react-router-dom";
import ErrorPage from "@quest/shared/error-page";

// Import feature routes
import { homeRoutes } from "./student/home-routes";
import { assignmentsRoutes } from "./student/assignments-routes";
import { journalRoutes } from "./student/journal-routes";
import { announcementsRoutes } from "./student/announcements-routes";
import { documentsRoutes } from "./student/documents-routes";
import { otherRoutes } from "./student/other-routes";

const FallbackLoader = () => {
  return <Loader />;
};

const LoginProcessPage = lazy(() => import("@/features/auth/pages/login-process"));
const NotFoundPage = lazy(() => import("@/features/not-found/auth-failed"));
const PageNotFoundPage = lazy(
  () => import("@/features/not-found/page-not-found")
);

export const studentRoutes: RouteObject[] = [
  {
    path: "/",
    children: [
      {
        path: "/",
        element: (
          <Suspense fallback={<FallbackLoader />}>
            <StudentLayout />
          </Suspense>
        ),
        errorElement: <ErrorPage />,
        children: [
          ...homeRoutes,
          ...assignmentsRoutes,
          ...journalRoutes,
          ...announcementsRoutes,
          ...documentsRoutes,
          ...otherRoutes,
        ],
      },
      {
        path: "/callback",
        children: [{ path: "/callback", element: <LoginProcessPage /> }],
      },
      {
        path: "/admin/not-found",
        element: <NotFoundPage />,
      },
      {
        path: "*",
        element: <PageNotFoundPage />,
      },
    ],
  },
];
